module.exports = __webpack_public_path__ + "static/img/guide_icon_top.0e9d7d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide_icon_top.png
// module id = GtCs
// module chunks = 1